import React from "react";
import { Button, Typography, Box } from "@mui/material";
import VisuallyHiddenInput from "../VisuallyHiddenInput";

const BackgroundImageUpload = ({
  posterPreviews,
  handlePosterFilesChange,
  formik,
}) => {
  return (
    <Box>
      {posterPreviews.length > 0 &&
      posterPreviews.some((poster) => poster.name === "background") ? (
        <img
          src={
            posterPreviews.find((poster) => poster.name === "background")?.url
          }
          alt="Poster preview"
          style={{
            width: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        formik.values.type === "WATCH" && (
          <>
            <Typography margin={"10px 0px"} component={"p"}>
              Add Background Image
            </Typography>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              sx={{ width: "100%", padding: "10px" }}
            >
              Upload file
              <VisuallyHiddenInput
                type="file"
                accept="image/jpeg, image/png, image/gif"
                name="background"
                onChange={handlePosterFilesChange}
              />
            </Button>
          </>
        )
      )}
    </Box>
  );
};

export default BackgroundImageUpload;
